/**
 *
 * @module tokenManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class TokenManagerConfiguration
 *
 */
export default class TokenManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/tokenManagerConfiguration.js